import imageViewer from './src/image-viewer';

// /* istanbul ignore next */
// Image.install = function(Vue) {
//   Vue.component('imageViewer', imageViewer);
// };

export default imageViewer;
